
import { tns } from 'tiny-slider'

export default function() {
	const els = [...document.querySelectorAll('.lightbox-carousel-container')]
	els.map(el => setup(el))
}

function setup(el) {

	const carouselSliderEl = el.querySelector('.lightbox-carousel__inner')
	const carouselSlides = [...carouselSliderEl.querySelectorAll('.lightbox-carousel-slide')]
	const lightboxDialog = el.querySelector('.lightbox-carousel-dialog')
	const lightboxSliderEl = el.querySelector('.lightbox-carousel-dialog__inner')
	const closeButton = lightboxDialog.querySelector('.js-lightbox-carousel-dialog-close')
	
	closeButton?.addEventListener('click', () => closeDialog(lightboxDialog))
	
	carouselSliderEl.addEventListener('click', (event) => {
		if (!event.defaultPrevented) openDialog(lightboxDialog)
	})

    const carousel = tns({
        container: carouselSliderEl,
		items: 1,
		slideBy: 1,
		autoplay: false,
		controls: true,
		nav: true,
		mouseDrag: true,
		autoplayButton: false,
		autoplayButtonOutput: false,
		speed: 700,
		edgePadding : 0,
		controlsText: ["Previous", "Next"]
    })

    const lightbox = tns({
        container: lightboxSliderEl,
		items: 1,
		slideBy: 1,
		autoplay: false,
		controls: true,
		nav: false,
		mouseDrag: true,
		autoplayButton: false,
		autoplayButtonOutput: false,
		speed: 700,
		controlsText: ["Previous", "Next"],
		edgePadding : 0,
    })

    // match both sliders
    lightbox.events.on('transitionStart', info => {	
    	carousel.goTo(info.displayIndex - 1)
    })

    let isOpen = false

    function openDialog() {
    	isOpen = true
    	const info = carousel.getInfo()
    	lightbox.goTo(info.displayIndex - 1)
    	lightboxDialog.style.display = 'block'
    	document.documentElement.style.overflow = 'hidden'
    }

    function closeDialog() {
    	isOpen = false
    	lightboxDialog.style.display = 'none'
    	document.documentElement.style.overflow = ''
    }

    window.addEventListener('keydown', event => {
    	if (!isOpen) return
    	const escKey = (event.key === 'Escape' || event.keyCode === 27)
    	if (escKey) closeDialog()
    })

    // arrows
    window.addEventListener('keydown', event => {
    	if (!isOpen) return
    	const info = lightbox.getInfo()
    	const actions = {
    		ArrowRight: () => {
    			if (document.activeElement !== info.nextButton) {
    				lightbox.goTo('next')
    			}
    		},
    		ArrowLeft: () => {
    			if (document.activeElement !== info.nextButton) {
    				lightbox.goTo('prev')
    			}
    		},
    	}
    	const action = actions[event.key]
    	if (action) action()
    })
}


